




import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Modal, Alert } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Setting = () => {
  const [images, setImages] = useState([]);
  const [banners, setBanners] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchBanner();
  }, []);

  // Fetch banner data from API
  const fetchBanner = async () => {
    try {
      const bannerResponse = await axios.get("https://api.bigfresh.in/fetch-banner");
      setBanners(bannerResponse.data.bannerDetail);
      console.log(bannerResponse.data.bannerDetail); 
    } catch (error) {
      console.log(error);
      setShowError(true);
      setErrorMessage("Failed to load banners.");
    }
  };


  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? banners.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === banners.length - 1 ? 0 : prev + 1));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setImages([selectedFile]);
      handleUpload(selectedFile);
    }
  };


  const handleUpload = async (file) => {
    const formData = new FormData();
    const maxSizeInBytes = 5 * 1024 * 1024; // 5MB max size

    if (file.size > maxSizeInBytes) {
      setShowError(true);
      setErrorMessage("Image is larger than 5MB.");
      return;
    }

    formData.append("image", file);

    try {
      const res = await axios.post(
        "https://api.bigfresh.in/banner",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      // Wrap the file into an object and update state
      setBanners((prev) => [...prev, { img: res.data.file }]);
      setShowModal(true);
    } catch (err) {
      console.error(err);
      setShowError(true);
      setErrorMessage("Error uploading image");
    }
  };

  // Handle banner removal
  // const handleRemoveBanner = async (bannerId) => {
  //   try {
  //     await axios.delete(`https://api.bigfresh.in/delete-banner/${bannerId}`);
  //     setBanners((prev) => prev.filter((banner) => banner.id !== bannerId));
  //     toast.success("Banner deleted successfully!", { position: "top-center" });
  //   } catch (error) {
  //     console.error(error);
  //     setShowError(true);
  //     setErrorMessage("Failed to remove the banner.");
  //     toast.error("Failed to remove the banner", { position: "top-center" });
  //   }
  // };

  const handleRemoveBanner = async (bannerId) => {
  try {
    await axios.delete(`https://api.bigfresh.in/delete-banner/${bannerId}`);

    setBanners((prev) => {
      const updated = prev.filter((banner) => banner.id !== bannerId);

      // ✅ FIX: adjust currentIndex safely
      setCurrentIndex((prevIndex) => {
        if (updated.length === 0) return 0;

        // if deleted last item → move back
        if (prevIndex >= updated.length) {
          return updated.length - 1;
        }

        return prevIndex;
      });

      return updated;
    });

    toast.success("Banner deleted successfully!", { position: "top-center" });

  } catch (error) {
    console.error(error);
    setShowError(true);
    setErrorMessage("Failed to remove the banner.");
    toast.error("Failed to remove the banner", { position: "top-center" });
  }
};

  return (
    <>
      <div className="dashboard-container">
        <div className="main-dashboard">
          <h4 className="fw-bold text-success text-center">Banner Section</h4>

          {showError && <Alert variant="danger">{errorMessage}</Alert>}

          <div id="bannerCarousel" className="carousel slide" data-bs-ride="false">
            <div className="carousel-inner">
        

              {banners.map((banner, index) => {
  if (!banner?.img) return null;

  const cleanPath = banner.img?.replace(/\\/g, "/");
  const fileUrl = `https://api.bigfresh.in${cleanPath}`;

  if (cleanPath.endsWith(".mp4")) {
    return (
      <div key={banner.id} className={`carousel-item ${index === currentIndex ? "active" : ""}`}>
        <video
          src={fileUrl}
          className="d-block w-100"
          autoPlay
          muted
          style={{ maxHeight: "350px", objectFit: "cover" }}
        />
      </div>
    );
  } 
  else if (
    cleanPath.endsWith(".gif") ||
    cleanPath.endsWith(".jpg") ||
    cleanPath.endsWith(".png") ||
    cleanPath.endsWith(".webp")   
  ) {
    return (
      <div key={banner.id} className={`carousel-item ${index === currentIndex ? "active" : ""}`}>
        <img
          src={fileUrl}
          className="d-block w-100"
          alt="banner"
          style={{ maxHeight: "350px", objectFit: "cover" }}
        />
      </div>
    );
  }

  return null;
})}


            </div>

           
            {banners[currentIndex] && (
              <button
                type="button"
                className="btn btn-danger position-absolute top-0 end-0 m-3"
                style={{ zIndex: 2000 }}
                onClick={() => handleRemoveBanner(banners[currentIndex].id)}
                // onClick={() => handleRemoveBanner(banners.id)}
              >
                Remove
              </button>
            )}


            <button
              className="carousel-control-prev text-black"
              type="button"
              data-bs-target="#bannerCarousel"
              data-bs-slide="prev"
              onClick={prevSlide}
            >
              <span className="carousel-control-prev-icon custom-prev text-black" />
            </button>

            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#bannerCarousel"
              data-bs-slide="next"
              onClick={nextSlide}
            >
              <i className="bi bi-chevron-right fs-2 text-white"></i>
            </button>
          </div>

          {/* Upload Banner Section */}
          <div className="banner-upload mt-4">
            <label className="file-upload-label">Upload Banner Image</label>
            <input
              type="file"
              name="images"
              onChange={handleFileChange}
              className="form-control-file"
                  accept=".gif, .mp4"  
            />
          </div>
          <ToastContainer />
        </div>
      </div>

      {/* Modal for Confirmation */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Upload Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Your banner image has been uploaded successfully!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Styles for the Component */}
      <style>{`
        .slider-container {
          position: relative;
          width: 100%;
          height: 260px;
          overflow: hidden;
        }

        .slider-inner {
          display: flex;
          transition: transform 0.5s ease-in-out;
        }

        .slider-item {
          min-width: 100%;
          box-sizing: border-box;
        }

        .slider-image {
          width: 100%;
          height: 260px;
          object-fit: cover;
          border-radius: 10px;
        }

        .remove-banner-btn {
          position: absolute;
          top: 10px;
          right: 10px;
          background-color: red;
          color: white;
          border: none;
          cursor: pointer;
        }

        .slider-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background-color: rgba(0, 0, 0, 0.5);
          color: white;
          border: none;
          padding: 10px;
          cursor: pointer;
          z-index: 10;
        }

        .slider-btn.left {
          left: 10px;
        }

        .slider-btn.right {
          right: 10px;
        }

        .banner-upload {
          margin-top: 20px;
        }

        .file-upload-label {
          font-size: 16px;
          font-weight: bold;
          display: block;
          margin-bottom: 10px;
        }

        .form-control-file {
          margin-top: 10px;
        }

        .image-preview {
          margin-top: 20px;
          text-align: center;
        }

        .preview-img {
          width: 200px;
          height: 120px;
          object-fit: cover;
          border-radius: 10px;
        }

        .alert {
          margin-top: 20px;
          font-weight: bold;
        }
      `}</style>
    </>
  );
};

export default Setting;
